import { useEffect, useState } from "react";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle } from "../../components/ui/dialog";
import { api, formatError } from "../../lib/api";
import { AdminTitle, AdminField, Panel } from "./AdminUi";

const EMPTY = { city: "", name: "", date: "", start_time: "", end_time: "", location: "", maps_url: "", status: "confirme", note: "" };
const ST = { confirme: "Confirmé", annule: "Annulé", brouillon: "Brouillon (non visible)" };

export const MarketEvents = () => {
  const [items, setItems] = useState([]);
  const [f, setF] = useState(null);
  const load = () => api.get("/admin/markets").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    try {
      if (f.id) await api.put(`/admin/markets/${f.id}`, f); else await api.post("/admin/markets", f);
      toast.success("Marché enregistré"); setF(null); load();
    } catch (err) { toast.error(formatError(err)); }
  };
  const del = async (m) => { if (window.confirm(`Supprimer ${m.name} ?`)) { await api.delete(`/admin/markets/${m.id}`); load(); } };
  const today = new Date().toISOString().slice(0, 10);

  return (
    <div data-testid="admin-market-events">
      <AdminTitle title="Marchés exceptionnels" action={<button className="btn-outline-gold !py-3" onClick={() => setF({ ...EMPTY })} data-testid="admin-add-market-button"><Plus className="h-4 w-4" />Ajouter une date</button>}>
        Salons, fêtes ou marchés ponctuels, ajoutés au calendrier à leur date.
      </AdminTitle>
      <div className="space-y-3">
        {items.map((m) => (
          <Panel key={m.id} className={`p-4 flex items-center gap-4 ${m.date < today ? "opacity-50" : ""}`} data-testid={`admin-market-${m.id}`}>
            <div className="flex-1 min-w-0">
              <p className="font-display text-xl truncate">{m.name} — {m.city}</p>
              <p className="text-xs text-[#F8F6F1]/50">{m.date} {m.start_time}{m.end_time && `–${m.end_time}`} · {ST[m.status]}{m.date < today ? " · passé" : ""}</p>
            </div>
            <button onClick={() => setF({ ...EMPTY, ...m })} className="p-2 hover:text-[#C9A45C]" aria-label="Modifier" data-testid={`admin-edit-market-${m.id}`}><Pencil className="h-4 w-4" /></button>
            <button onClick={() => del(m)} className="p-2 hover:text-red-400" aria-label="Supprimer" data-testid={`admin-delete-market-${m.id}`}><Trash2 className="h-4 w-4" /></button>
          </Panel>
        ))}
        {!items.length && <p className="text-sm text-[#F8F6F1]/45">Aucun marché exceptionnel.</p>}
      </div>
      <Dialog open={!!f} onOpenChange={(o) => !o && setF(null)}>
        <DialogContent className="bg-[#101010] border-[#C9A45C]/30 max-w-lg max-h-[90vh] overflow-y-auto">
          <DialogTitle className="font-display text-2xl font-normal">{f?.id ? "Modifier la date" : "Nouveau marché exceptionnel"}</DialogTitle>
          {f && (
            <form onSubmit={save} className="grid sm:grid-cols-2 gap-4" data-testid="market-form">
              <AdminField label="Nom" required value={f.name} onChange={set("name")} testid="market-form-name" />
              <AdminField label="Ville" required value={f.city} onChange={set("city")} testid="market-form-city" />
              <AdminField label="Date" type="date" required value={f.date} onChange={set("date")} testid="market-form-date" />
              <label className="block"><span className="text-[10px] tracking-[0.2em] uppercase text-[#F8F6F1]/50">Statut</span>
                <select value={f.status} onChange={set("status")} className="mt-1.5 w-full bg-[#0B0B0B] border border-[#C9A45C]/25 px-3 py-2.5 text-sm" data-testid="market-form-status">
                  {Object.entries(ST).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                </select>
              </label>
              <AdminField label="Début" type="time" value={f.start_time} onChange={set("start_time")} testid="market-form-start" />
              <AdminField label="Fin" type="time" value={f.end_time} onChange={set("end_time")} testid="market-form-end" />
              <AdminField className="sm:col-span-2" label="Adresse ou emplacement" value={f.location} onChange={set("location")} testid="market-form-location" />
              <AdminField className="sm:col-span-2" label="Lien Google Maps (facultatif)" value={f.maps_url} onChange={set("maps_url")} />
              <AdminField className="sm:col-span-2" label="Remarque (facultatif)" value={f.note} onChange={set("note")} />
              <div className="sm:col-span-2 flex justify-end gap-3">
                <button type="button" onClick={() => setF(null)} className="btn-outline-gold !py-3">Annuler</button>
                <button type="submit" className="btn-gold !py-3" data-testid="market-form-submit">Enregistrer</button>
              </div>
            </form>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};
